import type { CallConnection, ConnectionType } from 'store/call/call.state';
import type { InitiationType } from 'views/Home/Monitoring/types';

export const getInitiationType = (type: ConnectionType, status: connect.ConnectionStateType | string): InitiationType => {
    let initiationType: InitiationType = 'Unknown';

    if (status === connect.ConnectionStateType.CONNECTING) return 'Connecting';

    switch (type) {
        case 'MONITOR':
            initiationType = 'Monitoring';
            break;
        case 'BARGE':
            initiationType = 'Barging';
            break;
        case 'AGENT':
            initiationType = 'Connected agent';
            break;
        case 'QC_TRANSFER':
            initiationType = 'Transferred agent';
            break;
        case 'OUTBOUND_TRANSFER':
            initiationType = 'External outbound';
            break;
        case 'CUSTOMER':
            initiationType = 'Call started';
            break;
    }

    return initiationType;
};

// Sort connections via length of time in call and then extract the customer connection to first place
export const sortConnections = (connections: CallConnection[]): CallConnection[] => {
    if (connections.length <= 1) return connections;

    const sortedConnections = connections.sort((a, b) => {
        const dateA = a.start?.getTime();
        const dateB = b.start?.getTime();

        if (dateA && dateB) {
            return dateA - dateB;
        } else if (dateA) {
            return -1;
        } else if (dateB) {
            return 1;
        }
        return 0;
    });

    const customerConnectionIndex = sortedConnections.findIndex(({ type }) => type === 'CUSTOMER');

    // Return the sorted connections if the customer connection is already at the start of the array or it doesn't exist
    if (customerConnectionIndex <= 0) return sortedConnections;

    const customerConnections = sortedConnections.splice(customerConnectionIndex, 1);

    sortedConnections.unshift(customerConnections[0]);

    return sortedConnections;
};
